class GetAccountingSessionsEnteriesReq {
    constructor(){
        this.TherapistId = undefined;
        this.PatientId = undefined;
        this.SearchDate = undefined;
        this.DayId = undefined;
        this.pagingParams = {
            pageNumber : undefined,
            pageSize : undefined
        }
    }
}

export default GetAccountingSessionsEnteriesReq;